import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppComponent } from "src/app/app.component";
import { ApiService } from "src/app/services/api.service";
import swal from 'sweetalert2';

@Component({
  selector: 'app-sso-login',
  templateUrl: './sso-login.component.html',
  styleUrls: ['./sso-login.component.css']
})
export class SsoLoginComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private appComponent: AppComponent
  ) { }

  ngOnInit() {
    const token = this.route.snapshot.queryParamMap.get('token');

    console.log('SSO token URL:', token);

    if (!token) {
      console.warn('SSO: token no encontrado en URL');
      this.router.navigate(['/login'], { replaceUrl: true });
      return;
    }

    // limpiar URL
    window.history.replaceState({}, document.title, window.location.pathname);

    this.api.ssoLogin({ token: token }).subscribe({
      next: (res: any) => {

        console.log('SSO respuesta backend:', res);

        // 🔴 VALIDACIÓN
        if (!res || !res.user || !res.user.usu_id || !res.token) {
          console.error('SSO respuesta inválida:', res);
          swal.fire('Error', 'Respuesta inválida del servidor', 'error');
          this.router.navigate(['/login'], { replaceUrl: true });
          return;
        }

        // ✅ GUARDAR SESSION
        sessionStorage.setItem('token', res.token);
        sessionStorage.setItem('usuario', String(res.user.usu_id));

        console.log('SSO session guardada:', {
          token: res.token,
          usuario: res.user.usu_id
        });

        const datausuario = {
          p_usu_id: res.user.usu_id,
          p_usu_apepat: '',
          p_usu_apemat: '',
          p_usu_nombre: '',
          p_usu_loging: '',
          p_usu_chkadm: 9,
          p_usu_activo: 9
        };

        console.log('SSO request datos usuario:', datausuario);

        this.api.getDatosUsuario(datausuario).subscribe({
          next: (datos: any) => {

            console.log('SSO datos usuario response:', datos);

            if (!datos || !datos.length) {
              swal.fire('Error', 'No se encontraron datos del usuario', 'error');
              this.router.navigate(['/login'], { replaceUrl: true });
              return;
            }

            const user = datos[0];
            const ageId = (user && user.age_id != null) ? user.age_id : 0;

            // ✅ GUARDAR DATOS USUARIO
            sessionStorage.setItem('age_id', String(ageId));
            sessionStorage.setItem('usu_apepat', user.usu_apepat || '');
            sessionStorage.setItem('usu_apemat', user.usu_apemat || '');
            sessionStorage.setItem('usu_nombre', user.usu_nombre || '');
            sessionStorage.setItem('usu_nomcom', user.usu_nomcom || '');
            sessionStorage.setItem('usu_correo', user.usu_correo || '');
            sessionStorage.setItem('usu_chkadm', String(user.usu_chkadm || ''));
            sessionStorage.setItem('age_chkall', String(user.age_chkall || ''));
            sessionStorage.setItem('ust_descri', user.ust_descri || '');
            sessionStorage.setItem('fed_numdoi', user.fed_numdoi || '');
            sessionStorage.setItem('prf_id', String(user.prf_id || ''));

            const dataMenu = { p_usu_id: res.user.usu_id };

            console.log('SSO request menú:', dataMenu);

            this.api.getSeguridadperfilusuarioobjetosel(dataMenu).subscribe({
              next: (datosMenu: any) => {

                console.log('SSO menú response:', datosMenu);

                sessionStorage.setItem('objetosMenu', JSON.stringify(datosMenu));

                if (Array.isArray(datosMenu) && datosMenu.length > 0) {
                  const primerAcceso = datosMenu.find(
                    (obj: any) => obj && obj.obj_enlace && obj.obj_enlace.trim() !== ''
                  );

                  if (primerAcceso) {
                    const ruta = '/' + primerAcceso.obj_enlace.trim();

                    console.log('SSO redirigiendo a:', ruta);

                    this.router.navigate([ruta]);
                    return;
                  }
                }

                swal.fire({
                  icon: 'warning',
                  title: 'Acceso denegado',
                  text: 'El usuario no tiene accesos requeridos para esta aplicación. Por favor, comuníquese con UFTI.',
                  confirmButtonText: 'ACEPTAR',
                  allowOutsideClick: false
                }).then(() => {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                });
              },
              error: (err) => {
                console.error('SSO error menú:', err);
                swal.fire('Error', 'No se pudo cargar el menú', 'error');
                this.router.navigate(['/login'], { replaceUrl: true });
              }
            });
          },
          error: (err) => {
            console.error('SSO error datos usuario:', err);

            const mensajeError = err && err.error && err.error.mensaje ? err.error.mensaje : 'Error al obtener los datos del usuario';

            swal.fire('Error', mensajeError, 'error');
            this.router.navigate(['/login'], { replaceUrl: true });
          }
        });
      },
      error: (err) => {
        console.error('SSO error backend:', err);

        const mensajeError = err && err.error && err.error.mensaje ? err.error.mensaje : 'Error de autenticación SSO';

        swal.fire('Error', mensajeError, 'error');
        this.router.navigate(['/login'], { replaceUrl: true });
      }
    });
  }

}
